import { ReloadOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

import DetailPageHeader from '../components/detail-page-header';
import WarehousePropertiesTable from '../components/downloader/warehouse-properties-table';
import { useAppDispatch } from '../hooks/use-app-dispatch';
import { type RootState } from '../reducers';
import { downloaderLoadWarehouseProperties } from '../reducers/downloader/reducer';

function DownloaderWarehouseProperties(): React.ReactElement {
  const dispatch = useAppDispatch();
  const downloaderWarehouseProperties = useSelector(
    (s: RootState) => s.Downloader.warehouse.properties,
  );
  const downloaderInProcess = useSelector(
    (s: RootState) => s.Downloader.inProcess,
  );

  const propertyCount = downloaderWarehouseProperties?.length ?? 0;
  const pageHeaderText = `Downloader warehouse properties${propertyCount ? ` (${propertyCount} items)` : ''}`;

  return (
    <>
      <DetailPageHeader
        title={pageHeaderText}
        actions={
          <>
            <Tooltip title="Reload all properties assigned to property">
              <Button
                icon={<ReloadOutlined />}
                onClick={(): void => {
                  dispatch(downloaderLoadWarehouseProperties(true));
                }}
                disabled={downloaderInProcess}
              >
                All assigned to property
              </Button>
            </Tooltip>

            <Tooltip title="Reload all properties not assigned to property">
              <Button
                icon={<ReloadOutlined />}
                onClick={(): void => {
                  dispatch(downloaderLoadWarehouseProperties(false));
                }}
                disabled={downloaderInProcess}
              >
                All not assigned to property
              </Button>
            </Tooltip>
          </>
        }
      />

      <WarehousePropertiesTable />
    </>
  );
}

export default DownloaderWarehouseProperties;
